module.exports = __webpack_public_path__ + "static/media/email_icon.89bb46e6.svg";